module.exports = __webpack_public_path__ + "static/img/title2.6449794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/title2.png
// module id = NcL+
// module chunks = 1